import React, { useEffect, useState } from 'react';
import { getMe, setProfile, uploadAvatar } from '../api/endpoints';
import { navigateTo } from '../utils/navigation';

export default function ProfileEditPage(): React.JSX.Element {
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [gender, setGender] = useState('');
  const [avatar, setAvatar] = useState<Blob | null>(null);

  useEffect(() => {
    void getMe().then((user) => {
      setName(user.name ?? '');
      setSurname(user.surname ?? '');
      setCountry(user.country ?? '');
      setCity(user.city ?? '');
      setBirthdate(user.birthdate ?? '');
      setGender(user.gender ?? '');
    });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await setProfile({ name, surname, country, city, birthdate, gender });
    if (avatar) await uploadAvatar(avatar);
    navigateTo('/profile');
  };

  return (
    <div className="stack-5" style={{ maxWidth: 560, marginInline: 'auto' }}>
      <h2 className="t-h2" style={{ margin: 0 }}>Edit <em>profile</em></h2>

      <form onSubmit={handleSubmit} className="card stack-5 profile-edit-form">
        <div className="profile-edit-grid">
          <input
            className="form-input"
            value={name}
            onChange={(e) => { setName(e.target.value); }}
            placeholder="First name"
            autoComplete="given-name"
          />
          <input
            className="form-input"
            value={surname}
            onChange={(e) => { setSurname(e.target.value); }}
            placeholder="Last name"
            autoComplete="family-name"
          />
          <input
            className="form-input"
            value={country}
            onChange={(e) => { setCountry(e.target.value); }}
            placeholder="Country"
            autoComplete="country-name"
          />
          <input
            className="form-input"
            value={city}
            onChange={(e) => { setCity(e.target.value); }}
            placeholder="City"
            autoComplete="address-level2"
          />
          <input
            className="form-input"
            type="date"
            value={birthdate}
            onChange={(e) => { setBirthdate(e.target.value); }}
            autoComplete="bday"
          />
          <input
            className="form-input"
            value={gender}
            onChange={(e) => { setGender(e.target.value); }}
            placeholder="Gender (optional)"
          />
        </div>

        <div className="stack-2">
          <span className="t-label">Profile photo</span>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => { setAvatar(e.target.files?.[0] ?? null); }}
            style={{ font: '400 var(--fs-small)/1.5 var(--f-text)', color: 'var(--ink-muted)' }}
          />
          <p className="t-small t-mute" style={{ margin: 0 }}>JPG · PNG · WebP · up to 5 MB</p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--s-2)' }}>
          <button type="submit" className="btn btn--primary btn--sm">Save changes</button>
          <button type="button" className="btn btn--ghost btn--sm" onClick={() => { navigateTo('/profile'); }}>Cancel</button>
        </div>
      </form>
    </div>
  );
}
